import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router';
import { groups, modesInGroup } from '@/config/modes.config';
import { HomeLayout } from './HomeLayout';
import { ModeCard } from './Home';

/** Mode cards of one group (e.g. One Blocker), inside the same frame as the home screen. */
export function GroupScreen() {
  const { t } = useTranslation();
  const { groupId } = useParams();
  const group = groups.find((g) => g.id === groupId);
  if (!group) return <Navigate to="/" replace />;

  return (
    <HomeLayout section={`${t(`group.${group.id}.name`)} · ${t('home.modes')}`} backTo="/">
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,360px),1fr))] gap-6">
        {modesInGroup(group.id).map((mode, i) => (
          <ModeCard key={mode.id} mode={mode} index={i} />
        ))}
      </div>
    </HomeLayout>
  );
}
